// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAbnffzp9WPxVNghV7TycSy-yiv6P6Uzd8",
    authDomain: "predyc-learning.firebaseapp.com",
    projectId: "predyc-learning",
    storageBucket: "predyc-learning.appspot.com",
    messagingSenderId: "1059432167907",
    appId: "1:1059432167907:web:52fd8f735d9ad7fa55c8d6",
    measurementId: "G-BV6CPRZKN6"
  },
  stripe: {
    testKey: 'pk_test_51J0sHxK9jeRSVMnk7spvb14NAWbe51J0dwShEdnMjaxa8PF2t9NexaCHIOS5gPzQjzpON1wTNWc0MUVWtWDLSG7K00qrJggAa8'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
